export default __webpack_public_path__ + "ebe82fda80c6544307c8f60cac8cb22b.png";